import { transform } from '@babel/core'
import React from 'react'

import { VisibilityContext } from 'react-horizontal-scrolling-menu'

export function Card({
  abo,
  overline,
  title,
  itemId,
  lead,
  icon,
  url,
  className
}: {
  abo: boolean
  overline: string
  title: string
  itemId: string
  lead: string
  icon: object
  url: string
  className: string
}) {
  const visibility = React.useContext(VisibilityContext)

  const visible = visibility.isItemVisible(itemId)

  const trackLinkClicks = target => {
    const clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'url: ' + clickedText
    })
  }

  return (
    <a
      href={url}
      target='_top'
      role='button'
      style={{
        display: 'inline-block',
        margin: '0 0px',
        width: '250px',
        userSelect: 'none'
      }}
      tabIndex={0}
      className={`card ${className}`}
      onClick={() => trackLinkClicks({ url })}
    >
      <div className='content'>
        <div className='row content'>
          <div className='col icon'>
            <div className='icon'>{icon}</div>
          </div>
          <div className='col'>
            <div className='row overline'>
              {abo && <span>Abo</span>}
              {overline}
            </div>
            <h3 className='title'>{title}</h3>
          </div>
        </div>
      </div>

      {/* <div style={{ backgroundColor: visible ? "transparent" : "gray" }}>
          visible: {JSON.stringify(visible)}
        </div> */}
    </a>
  )
}
